export default function scrollToTop() {
  requestAnimationFrame(() =>
    window.scrollTo({
      top: document.documentElement.offsetTop,
      behavior: 'smooth'
    })
  );
}
